export const DRIVERS_BOARD_TUTORIAL_STEPS = [
  {
    target: '#drivers-board-intro',
    title: 'Choferes',
    content:
      'Acá seguís a cada chofer por separado. Podés ver quién está activo, qué unidad usa y cómo viene trabajando.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightPadding: 12,
  },
  {
    target: '#drivers-board-header',
    title: 'Cabecera del módulo',
    content:
      'Desde esta cabecera volvés a Logística, creás un nuevo registro y ubicás rápido esta sección.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightPadding: 12,
  },
  {
    target: '#drivers-board-list',
    title: 'Base de choferes',
    content:
      'Acá ves la base de choferes. Cada fila resume quién es y en qué estado está.',
    placement: 'right',
    disableBeacon: true,
    spotlightPadding: 12,
  },
  {
    target: '#drivers-board-first-card',
    title: 'Ficha resumida',
    content:
      'Cuando tocás un chofer, abrís su ficha resumida sin salir de esta pantalla.',
    placement: 'right',
    disableBeacon: true,
    spotlightPadding: 12,
  },
  {
    target: '#drivers-board-report-header',
    title: 'Informe fijo',
    content:
      'Este panel te muestra el resumen del chofer elegido: acceso, unidad actual y estado.',
    placement: 'left',
    disableBeacon: true,
    spotlightPadding: 12,
  },
  {
    target: '#drivers-board-kpis',
    title: 'Indicadores',
    content:
      'Estos indicadores te ayudan a leer rápido cómo viene trabajando ese chofer.',
    placement: 'left',
    disableBeacon: true,
    spotlightPadding: 12,
  },
  {
    target: '#drivers-board-recent-history',
    title: 'Historia reciente',
    content:
      'Acá ves la actividad reciente del chofer. Si necesitás más detalle, podés abrir el historial completo.',
    placement: 'left',
    disableBeacon: true,
    spotlightPadding: 12,
  },
  {
    target: '#drivers-board-route-history',
    title: 'Historial completo',
    content:
      'Cuando abrís todo el historial, ves los recorridos de ese chofer y podés entrar al detalle de cada día.',
    placement: 'left',
    disableBeacon: true,
    spotlightPadding: 12,
  },
];
